import layout from 'styles/LandingLayout.module.scss';
import ParagraphWrapper from 'components/landing/components/paragraph-wrapper';
import PropTypes from 'prop-types';
import RangeComparatorWidget from 'components/widgets/range-comparator-table/table';
import SectionTitle from '../components/section-title';
import style from 'styles/LandingComponents.module.scss';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';

const PremiumPrice = ({ data }) => {
    const { seoText, verification, createdDate } =
        useGetSeoTextByIndex('premium_price');

    if (!verification) {
        return null;
    }

    const itemList = [
        seoText.list.item1,
        seoText.list.item2,
        seoText.list.item3
    ];

    return (
        <div
            className={`
                ${layout.landing__section_gradient_background}
                ${layout.landing__section_wrapper}`}
        >
            <div className={layout.landing__section_content}>
                <SectionTitle date={createdDate} maxWidth={750}>
                    {seoText.section_title}
                </SectionTitle>
                <div className={style.premium_price_section}>
                    <ParagraphWrapper tag="div">
                        <p>
                            {seoText.paragraph1.sentence1}
                            {seoText.paragraph1.sentence2}
                            {seoText.paragraph1.sentence3}
                            {seoText.paragraph1.sentence4}
                            {seoText.paragraph1.sentence5}
                        </p>
                        <ol>
                            {itemList.map((item) => (
                                <li key={item}>
                                    <strong>{item}</strong>
                                </li>
                            ))}
                        </ol>
                    </ParagraphWrapper>
                    <RangeComparatorWidget
                        data={data}
                    />
                </div>
                <ParagraphWrapper>
                    {seoText.paragraph2.sentence1}
                    {seoText.paragraph2.sentence2}
                    {seoText.paragraph2.sentence3}
                    {'\n'}
                </ParagraphWrapper>
                <ParagraphWrapper>
                    {seoText.paragraph3.sentence1}
                    {seoText.paragraph3.sentence2}
                    {seoText.paragraph3.sentence3}
                </ParagraphWrapper>
            </div>
        </div>
    );
};

PremiumPrice.propTypes = {
    data: PropTypes.array
};

export default PremiumPrice;
